import type { AuthUser } from '@/types/auth';
import { pb } from './api';
import { invalidateAccessCache } from './access-check';
import { mapRecordToUser } from './auth-mapping';

export async function loginWithPassword(
  email: string,
  password: string
): Promise<AuthUser> {
  const result = await pb
    .collection('team_members')
    .authWithPassword(email, password);
  const user = mapRecordToUser(result.record);
  if (!user.is_active) {
    pb.authStore.clear();
    throw new Error('Cuenta desactivada');
  }
  invalidateAccessCache();
  return user;
}

export function logout(): void {
  pb.authStore.clear();
  invalidateAccessCache();
}

export async function refreshAuth(): Promise<AuthUser> {
  const result = await pb.collection('team_members').authRefresh();
  const user = mapRecordToUser(result.record);
  if (!user.is_active) {
    pb.authStore.clear();
    throw new Error('Cuenta desactivada');
  }
  return user;
}

export function getCurrentUser(): AuthUser | null {
  const record = pb.authStore.record;
  if (!record) return null;
  return mapRecordToUser(record);
}

export function isAdmin(): boolean {
  return pb.authStore.record?.['role'] === 'admin';
}
